import { emailList } from '../enhance/email-list';
import { setFieldError, setSummaryError } from '../enhance/forms';

const redirectRequired = 'The Redirect URL for applications is required.';
const emailRequired = 'Enter at least one email.';

// Job/Add and Job/Edit: applications go either to a redirect URL (mode 1) or to
// a list of email addresses (mode 2). Switching clears the other side, and the
// form can't be submitted without the chosen one filled in.
export function applicationMode({ form, mode, emails = [] }) {
  const redirectSection = form.querySelector('.appRedirectUrl');
  const emailSection = form.querySelector('.appEmail');
  const redirectInput = form.querySelector('#ApplicationRedirectUrl');
  const redirectError = form.querySelector('.appRedirectUrlError');
  const emailError = form.querySelector('.appEmailError');
  const list = emailList(emailSection.querySelector('input'), emails);

  const selected = () => Number(form.querySelector('input[name="ApplicationMode"]:checked')?.value ?? mode);

  const show = (current) => {
    redirectSection.style.display = current === 1 ? '' : 'none';
    emailSection.style.display = current === 1 ? 'none' : '';
  };

  form.querySelectorAll('input[name="ApplicationMode"]').forEach((radio) => {
    radio.addEventListener('change', () => {
      if (selected() === 1) {
        list.reset();
        setFieldError(redirectError, '');
      } else {
        redirectInput.value = '';
        setFieldError(emailError, '');
      }

      show(selected());
    });
  });

  list.entry.addEventListener('focus', () => setFieldError(emailError, ''));
  show(mode);

  form.addEventListener('submit', (event) => {
    if (selected() === 1) {
      const missing = !redirectInput.value.trim();

      if (missing) {
        event.preventDefault();
        redirectInput.focus();
      }

      setFieldError(redirectError, missing ? redirectRequired : '');
      setSummaryError('redirect-url-required', missing ? redirectRequired : '');
      setSummaryError('application-email-required', '');
    } else {
      const missing = list.count() === 0;

      if (missing) {
        event.preventDefault();
        list.entry.focus();
      }

      setFieldError(emailError, missing ? emailRequired : '');
      setSummaryError('application-email-required', missing ? emailRequired : '');
      setSummaryError('redirect-url-required', '');
    }
  });
}
